import request from '@/utils/request'
import { _GLOBAL } from '@/api/server'

export function loginByUsername (username, password) {
  // console.log('on api loginByUsername')
  var data = {
    identifier: username,
    password: password
  }
  var uri = _GLOBAL.URLBACKEND + '/auth/local'
  // console.log(uri)
  var response = request({
    url: uri,
    method: 'post',
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    },
    data
  })
  // console.log(response)
  return response
}

/* AS JWT TOKEN NO NEED TO LOGOUT USING STRAPI
export function logout() {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}
*/

export function getUserInfo (token, userid) {
  // console.log('on api getUserInfo')
  if (userid.length === 0) return null

  var uri = _GLOBAL.URLBACKEND + '/users/' + userid
  var data = ''
  // console.log(uri)
  var response = request({
    url: uri,
    method: 'get',
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    },
    data
  })
  // console.log(response)
  return response
}

export function forgotPassword (mailaddr) {
  console.log('on api forgotPassword')
  if (mailaddr.length === 0) return null
  var uri = _GLOBAL.URLBACKEND + '/auth/forgot-password'
  var data = {
    email: mailaddr,
    url: _GLOBAL.URL + '/admin/plugins/users-permissions/auth/reset-password'
  }
  // console.log(uri)
  console.log(data)
  axios
  .post(uri, {
    email: mailaddr,
    url:
    _GLOBAL.URL + '/admin/plugins/users-permissions/auth/reset-password'
  })
  .then(response => {
    // Handle success.
    console.log('Your user received an email')
    // console.log(response)
    return response
  })
  .catch(error => {
    // Handle error.
    console.log('An error occurred:', error)
    return error
  })
  /*
  var response = request({
    url: uri,
    method: 'post',
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    },
    data
  })
  */
  // console.log(response)
  // return response
}

export function resetPassword (code, pass, passconfirm) {
  // console.log('on api resetPassword')
  if (code.length === 0) return null
  if (pass.length === 0) return null
  if (passconfirm.length === 0) return null

  var uri = _GLOBAL.URLBACKEND + '/auth/reset-password'
  var data = {
    code: code,
    password: pass,
    passwordConfirmation: passconfirm
  }
  // console.log(uri)
  // console.log(data)
  var response = request({
    url: uri,
    method: 'post',
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    },
    data
  })
  // console.log(response)
  return response
}
